import { t as __exportAll } from "./chunk-CfYAbeIz.mjs";
import micromatch from "micromatch";
import * as R from "ramda";
import { Type } from "typebox";
import "typebox/system";
import "typebox/format";
import "typebox/guard";
//#region src/constants.ts
const EMAIL_ATTRIBUTE = "email";
const GROUPS_ATTRIBUTE = "cognito:groups";
const STAGE_ATTRIBUTE = "custom:Stage";
const INTERNAL_ATTRIBUTE = "custom:Internal";
//#endregion
//#region src/schemas.ts
const LLPermissionLevelSchema = Type.Enum([
	"R",
	"RW",
	"ADMIN",
	"OWNER",
	"DENY"
]);
const LLPermissionSchema = Type.Union([Type.Object({
	name: Type.String({ pattern: /^[^*]*\*?$/ }),
	permission: Type.Enum([
		"R",
		"RW",
		"ADMIN",
		"OWNER"
	])
}), Type.Object({
	name: Type.String({ pattern: /^[^*]*$/ }),
	permission: Type.Literal("DENY")
})], { title: "LLIAM Permission" });
const LLPolicySchema = Type.Object({
	groups: Type.Optional(Type.Array(LLPermissionSchema)),
	groupMembership: Type.Optional(Type.Array(LLPermissionSchema)),
	objectstores: Type.Optional(Type.Array(LLPermissionSchema)),
	beacons: Type.Optional(Type.Array(LLPermissionSchema)),
	mapnotes: Type.Optional(Type.Array(LLPermissionSchema)),
	assets: Type.Optional(Type.Array(LLPermissionSchema)),
	internaltools: Type.Optional(Type.Array(LLPermissionSchema)),
	mapsyndication: Type.Optional(Type.Array(LLPermissionSchema)),
	mapsondisplay: Type.Optional(Type.Array(LLPermissionSchema)),
	people_insight_dashboards: Type.Optional(Type.Array(LLPermissionSchema))
}, { title: "LLIAM Policy" });
//#endregion
//#region src/validators/llpermission.ts
let External$1 = [];
function SetExternal$1(external) {
	External$1 = external.variables;
}
const check_2bc5822166bf4786$1 = ((value) => typeof value === "object" && value !== null && !Array.isArray(value) && "name" in value && "permission" in value && typeof value.name === "string" && External$1[0].test(value.name) && (value.permission === "R" || value.permission === "RW" || value.permission === "ADMIN" || value.permission === "OWNER") || typeof value === "object" && value !== null && !Array.isArray(value) && "name" in value && "permission" in value && typeof value.name === "string" && External$1[1].test(value.name) && typeof value.permission === "string" && value.permission === "DENY");
function Check$1(value) {
	return check_2bc5822166bf4786$1(value);
}
SetExternal$1({ variables: [/^[^*]*\*?$/, /^[^*]*$/] });
//#endregion
//#region src/llpermission.ts
const PERMISSIONS = {
	OWNER: 5,
	DENY: 4,
	ADMIN: 3,
	RW: 1,
	R: 0
};
const PERMISSION_LEVELS = {
	OWNER: "OWNER",
	DENY: "DENY",
	ADMIN: "ADMIN",
	READWRITE: "RW",
	READ: "R"
};
const OWNER = PERMISSION_LEVELS.OWNER;
const DENY = PERMISSION_LEVELS.DENY;
const ADMIN = PERMISSION_LEVELS.ADMIN;
const READWRITE = PERMISSION_LEVELS.READWRITE;
const READ = PERMISSION_LEVELS.READ;
/**
* @param array
* @param attribute
* @returns that only contains objects with unique values for given "attribute"
*/
const removeDuplicatesByAttribute = (array, attribute) => R.uniqBy(R.path([attribute]), array);
/**
* @param permissionArray array of permissions
* @returns array of permissions, sorted in order of permission level, with no redundant permissions
*/
const removeRedundantPermissions = (permissionArray) => {
	return removeDuplicatesByAttribute(sortPermissionArray(permissionArray), "name");
};
/**
* @param permissionArray array of permissions
* @returns array of permissions, sorted in order of permission level.
*/
const sortPermissionArray = (permissionArray) => permissionArray.sort((a, b) => PERMISSIONS[b.permission] - PERMISSIONS[a.permission]);
/**
* @param permission the permission to check
* @param minimumPermission the minimum permission
* @returns check to see if permission is at least the minimum permission, and false if DENY
*/
const permissionIsAtLeast = (permission, minimumPermission) => {
	if (!permission) return false;
	if (permission === DENY) return false;
	return PERMISSIONS[permission] >= PERMISSIONS[minimumPermission];
};
/**
* @param resource of the resource
* @param permission to above resource
*/
const createPermission = (resource, permission) => ({
	name: resource,
	permission
});
/**
* @param permission to validate
* @returns representing if the policy is valid
*/
const validate = (permission) => {
	if (!permission) return false;
	return Check$1(permission);
};
//#endregion
//#region src/validators/llpolicy.ts
let External = [];
function SetExternal(external) {
	External = external.variables;
}
const check_2bc5822166bf4786 = ((value) => typeof value === "object" && value !== null && !Array.isArray(value) && (value.groups === void 0 || !("groups" in value) || Array.isArray(value.groups) && value.groups.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[0].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[1].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.groupMembership === void 0 || !("groupMembership" in value) || Array.isArray(value.groupMembership) && value.groupMembership.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[2].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[3].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.objectstores === void 0 || !("objectstores" in value) || Array.isArray(value.objectstores) && value.objectstores.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[4].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[5].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.beacons === void 0 || !("beacons" in value) || Array.isArray(value.beacons) && value.beacons.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[6].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[7].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.mapnotes === void 0 || !("mapnotes" in value) || Array.isArray(value.mapnotes) && value.mapnotes.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[8].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[9].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.assets === void 0 || !("assets" in value) || Array.isArray(value.assets) && value.assets.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[10].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[11].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.internaltools === void 0 || !("internaltools" in value) || Array.isArray(value.internaltools) && value.internaltools.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[12].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[13].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.mapsyndication === void 0 || !("mapsyndication" in value) || Array.isArray(value.mapsyndication) && value.mapsyndication.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[14].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[15].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.mapsondisplay === void 0 || !("mapsondisplay" in value) || Array.isArray(value.mapsondisplay) && value.mapsondisplay.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[16].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[17].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")) && (value.people_insight_dashboards === void 0 || !("people_insight_dashboards" in value) || Array.isArray(value.people_insight_dashboards) && value.people_insight_dashboards.every((element, index) => typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[18].test(element.name) && (element.permission === "R" || element.permission === "RW" || element.permission === "ADMIN" || element.permission === "OWNER") || typeof element === "object" && element !== null && !Array.isArray(element) && "name" in element && "permission" in element && typeof element.name === "string" && External[19].test(element.name) && typeof element.permission === "string" && element.permission === "DENY")));
function Check(value) {
	return check_2bc5822166bf4786(value);
}
SetExternal({ variables: [
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/,
	/^[^*]*\*?$/,
	/^[^*]*$/
] });
//#endregion
//#region src/llpolicy.ts
const PERMISSION_SETS = {
	OBJECTSTORES: "objectstores",
	GROUPS: "groups",
	GROUP_MEMBERSHIP: "groupMembership",
	MAPNOTES: "mapnotes",
	ASSETS: "assets",
	INTERNALTOOLS: "internaltools",
	BEACONS: "beacons",
	MAP_SYNDICATION: "mapsyndication",
	MAPS_ON_DISPLAY: "mapsondisplay",
	PEOPLE_INSIGHT_DASHBOARDS: "people_insight_dashboards"
};
const EMPTY_POLICY = {
	groups: [],
	groupMembership: [],
	objectstores: [],
	mapnotes: [],
	assets: [],
	beacons: [],
	internaltools: [],
	mapsyndication: [],
	mapsondisplay: [],
	people_insight_dashboards: []
};
/**
* @param policy
* @param permissionSet
* @returns array of permissions for this type, or if it doesn't exist, the empty policy permissions.
*/
const getPermissions = (policy, permissionSet) => policy[permissionSet] || EMPTY_POLICY[permissionSet];
/**
* @param a
* @param b
* @param reduce if the merged policy should be maximally reduced
* @returns policy where the permissions have been merged
*/
const mergePolicy = (a, b, reduce = true) => {
	const mergedPermissionSets = Object.values(PERMISSION_SETS).map((permissionSet) => {
		const permissionsA = getPermissions(a, permissionSet) ?? [];
		const permissionsB = getPermissions(b, permissionSet) ?? [];
		const allPermissions = permissionsA?.concat(permissionsB);
		const reducedPermissions = reduce ? reducePermissions(allPermissions) : allPermissions;
		return { [permissionSet]: removeRedundantPermissions(reducedPermissions) };
	});
	return Object.assign({}, ...mergedPermissionSets);
};
/**
* @param permissionArray
* @returns array of permissions where the permission array has been maximally reduced.
* This is done by filtering out any permission that is a subset of another llpermission with a higher permission
*/
const reducePermissions = (permissionArray) => {
	return permissionArray.filter(({ name: resource, permission }) => {
		const highestPermissionForResource = getPermissionForResource(permissionArray, resource);
		return PERMISSIONS[permission] >= PERMISSIONS[highestPermissionForResource];
	});
};
/**
* @param policy to duplicate
*/
const createPolicy = (policy = EMPTY_POLICY) => ({ ...policy });
/**
* @param policy original policy
* @param type attribute in llpolicy to append newPermission to
* @param newPermission permission to add to the objectstores array of policy
*/
const addPermission = (policy, type, newPermission) => {
	return mergePolicy(policy, Object.assign({}, EMPTY_POLICY, { [type]: [newPermission] }), false);
};
/**
* @param policy
* @param type attribute in llpolicy to append newPermission to
* @param resource the resource to find
* Search pattern:
* 1. Get all matches, and then sort by decreasing permission level
* 2. return the last permission in the list (whatever is the highest permission)
* example input:
*  {
*      objectstores: [
*          {
*              name: '*',
*              permission: 'RW'
*          },
*          {
*              name: '*-hello',
*              permission: 'ADMIN'
*          }
*       ]
*  },
* output if looking for world-hello:  'ADMIN'
*/
const getPermission = (policy, type, resource) => {
	return getPermissionForResource(policy[type], resource);
};
const getPermissionForResource = (set, resource) => {
	const resultPermission = sortPermissionArray(set?.filter(({ name: r }) => micromatch.isMatch(resource, r)) ?? []).shift()?.permission;
	if (resultPermission === DENY || !resource.includes("*")) return resultPermission;
	if ((set?.filter(({ name: r }) => micromatch.isMatch(r, resource)))?.shift()?.permission === DENY) return DENY;
	else return resultPermission;
};
/**
* @param policy
* @param type attribute in llpolicy to append newPermission to
* @param resource the resource to find
*/
const getExactPermission = (policy, type, resource) => policy[type]?.find(({ name: r }) => r === resource)?.permission;
/**
* @param policy
* @param type attribute in llpolicy to remove permission from
* @param resource the resource to remove
*/
const removePermission = (policy, type, resource) => {
	const newPermissions = policy[type]?.filter((permission) => permission.name !== resource);
	return Object.assign(policy, { [type]: newPermissions });
};
/**
* @param policy to validate
* @returns policy is valid
*/
const validate$1 = (policy) => {
	if (!policy) return false;
	return Check(policy);
};
/**
* @param permissionSet to validate
* @returns permission set is valid
*/
const isValidPermissionSet = (permissionSet) => Object.values(PERMISSION_SETS).includes(permissionSet);
//#endregion
//#region src/errors.ts
var errors_exports = /* @__PURE__ */ __exportAll({
	InvalidAction: () => InvalidAction,
	InvalidParameterError: () => InvalidParameterError,
	InvalidPermissionError: () => InvalidPermissionError,
	InvalidPolicyError: () => InvalidPolicyError,
	InvalidSubjectError: () => InvalidSubjectError,
	InvalidTokenError: () => InvalidTokenError,
	PermissionError: () => PermissionError
});
var LLIAMError = class extends Error {
	constructor(message) {
		super(message);
		this.name = this.constructor.name;
		Error.captureStackTrace(this, this.constructor);
	}
};
var InvalidSubjectError = class extends LLIAMError {
	constructor(subject) {
		super(`Invalid subject id [${subject}]`);
	}
};
var InvalidPolicyError = class extends LLIAMError {
	constructor() {
		super("Policy does not match llpolicy schema");
	}
};
var InvalidPermissionError = class extends LLIAMError {
	constructor() {
		super("Permission does not match llpermission schema");
	}
};
var InvalidAction = class extends LLIAMError {};
var InvalidTokenError = class extends LLIAMError {};
var InvalidParameterError = class extends LLIAMError {};
var PermissionError = class extends LLIAMError {
	constructor(subject, customMessage = false) {
		super(customMessage ? subject : `Subject does not have required permission [${subject}]`);
	}
};
//#endregion
//#region src/token.ts
/**
* @param token a decoded token (payload only)
* @returns the cognito pool id that this token belongs to
*/
const getPoolId = (token) => {
	return token.iss?.split("/").pop();
};
/**
* @param token a decoded token (payload only)
* @returns the subject of this token
*/
const getSubject = (token) => token["sub"];
/**
* @param token a decoded token (payload only)
* @returns the subject of this token
*/
const getUsername = (token) => token["username"];
/**
* @param token a decoded token (payload only)
* @returns the aws region of the cognito pool this token belongs to
*/
const getRegion = (token) => getPoolId(token)?.split("_")[0];
/**
* @param token a decoded token (payload only)
* @returns the cognito groups that this token belongs to
*/
const getGroups = (token) => token["cognito:groups"] || [];
/**
* @param token a decoded (payload only) token
* @param options options passed into the lliam constructor
* @returns if the cognito pool is one that we accept
* @throws {InvalidTokenError} if the cognito pool is invalid
*/
const validateIssuer = (token, options) => {
	const region = getRegion(token) ?? "unknown";
	const poolId = getPoolId(token) ?? "unknown";
	const { userPools } = options;
	if ((userPools ? userPools[region] ?? [] : []).includes(poolId)) return true;
	else throw new InvalidTokenError(`Invalid user pool [${poolId}]`);
};
//#endregion
//#region src/index.ts
const CONSTANTS = {
	EMAIL_ATTRIBUTE,
	GROUPS_ATTRIBUTE,
	STAGE_ATTRIBUTE,
	INTERNAL_ATTRIBUTE,
	PERMISSION_SETS,
	...PERMISSION_SETS,
	ADMIN,
	READWRITE,
	READ,
	OWNER,
	DENY
};
//#endregion
export { CONSTANTS, EMPTY_POLICY, LLPermissionLevelSchema, LLPermissionSchema, LLPolicySchema, PERMISSION_LEVELS, PERMISSION_SETS, addPermission, createPermission, createPolicy, errors_exports as errors, getExactPermission, getGroups, getPermission, getPermissions, getPoolId, getRegion, getSubject, getUsername, isValidPermissionSet, mergePolicy, permissionIsAtLeast, removePermission, sortPermissionArray, validateIssuer, validate as validatePermission, validate$1 as validatePolicy };

//# sourceMappingURL=index.mjs.map